/**
 * Used to tell a component that allows absolute positioning where on the screen to display itself.
 */
export enum ScreenPosition {
  TopLeft,
  Left,
  BottomLeft,
  Top,
  Center,
  Bottom,
  TopRight,
  Right,
  BottomRight,
}

export enum DomTargetPosition {
  TopLeft,
  TopRight,
  BottomLeft,
  BottomRight,
  Left,
  Right,
}

export enum DomElementAlignment {
  TopLeft,
  TopRight,
  BottomLeft,
  BottomRight,
}

export enum ModalDialogDefaultButtonSettings {
  OkCancel,
  YesNo,
  Custom,
}

export enum ModalDialogDockLocation {
  Top,
  Bottom,
  Left,
  Right,
}

export enum ModalDialogButtonReturnType {
  OK,
  Cancel,
  Yes,
  No,
  Custom,
}

export enum DataSearchLocation {
  Local,
  Api,
}
